import { render, staticRenderFns } from "./ModelRewardrecomment.vue?vue&type=template&id=100c8fe9&scoped=true&"
import script from "./ModelRewardrecomment.vue?vue&type=script&lang=js&"
export * from "./ModelRewardrecomment.vue?vue&type=script&lang=js&"
import style0 from "./ModelRewardrecomment.vue?vue&type=style&index=0&id=100c8fe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100c8fe9",
  null
  
)

export default component.exports